<template>
  <div v-if="azienda" class="h-100">
    <div
      class="general_border shadow_6 py-3 px-2 border min__30 h-100"
      :class="computedCardClass"
      @click="selectThis"
    >
      <p
        class="text-left ml-0 mb-0"
        :class="
          user.farmacia_preferita &&
          azienda.hashid === user.farmacia_preferita.hashid
            ? ''
            : 'hidden'
        "
      >
        <b-icon icon="heart-fill"></b-icon>
      </p>
      <p class="mb-0 fs-5 pt-1 text-center">
        <strong class="">{{ azienda.ff_denominazione }}</strong>
      </p>
      <p class="mb-0 mt-1 fs-5 text-font-grey text-center text-capitalize">
        {{ azienda.indirizzo }}, {{ azienda.frazione }} {{ azienda.comune }}
      </p>
      <p v-if="disabled" class="mb-0 mt-2 fs-5 text-danger text-center">
        <b-icon icon="exclamation-triangle-fill"></b-icon> Farmacia non attiva
      </p>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"
export default {
  name: "CompanyCard",
  props: ["azienda", "iselected", "disabled", "disablePoint"],
  computed: {
    ...mapState("utente", ["status", "user"]),
    computedCardClass() {
      return (
        this.backgroundClass + " " + this.borderClass + " " + this.pointClass
      )
    },
    backgroundClass() {
      if (this.disabled) {
        return "bg-lighter-grey"
      } else if (this.iselected) {
        return "bg-sec-3"
      } else {
        return "bg-white"
      }
    },
    borderClass() {
      if (this.disabled && !this.iselected) {
        return "border-medium-grey"
      } else if (this.iselected) {
        return "border-sec-2"
      } else {
        return "border-light-panel"
      }
    },
    pointClass() {
      if (this.disablePoint && this.disabled) {
        return ""
      } else {
        return "point"
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    selectThis() {
      this.$emit("company-selection", this.azienda)
    }
  }
}
</script>
<style>
.min__30 {
  min-height: 155px;
}
</style>
